import { useRef } from "react";

/*
  Custom hook used that exposes a method to scroll the element into the viewport.
  - By default the exposed method will only scroll the element into the view if the element is not yet in 
    the viewport, this behavior can be overridden by providing the alwaysScroll flag when calling the method
*/
export const useScrollIntoView = () => {
  const ref = useRef<HTMLDivElement>(null);

  const scrollIntoView = (alwaysScroll?: boolean, behavior?: ScrollBehavior) => {
    if (ref.current) {
      const { top, bottom } = ref.current.getBoundingClientRect();

      // check that the element is not yet in the viewport
      if (
        alwaysScroll ||
        top <= 0 ||
        bottom >= (window.innerHeight || document.documentElement.clientHeight)
      ) {
        const y = top + window.pageYOffset - 50;
        window.scrollTo({
          top: y,
          behavior: behavior || "smooth",
        });
      }
    }
  };

  return { ref, scrollIntoView };
};
